import { fork, takeLatest, call, put } from 'redux-saga/effects';

import {
  validateCards,
  validateCardsSuccess,
  validateCardFailure,
  createCardsInBulk,
  createCardsInBulkSuccess,
  createCardsInBulkFailure,
  addBulkCardResponse
} from '../slices/cardValidation';
import { validateBulkCardAPI, createBulkCardAPI } from '../../services/api';

function* validateCardsFunc(action) {
  const { history } = action.payload;
  const formData = new FormData();
  formData.append("uploaded_file", action.payload.file);
  formData.append('orderreference', action.payload.orderReference);
  formData.append("fileName", action.payload.fileName);
  formData.append("timezone", action.payload.timezone);

  try {
    const data = yield call(validateBulkCardAPI, formData);
    if (data) {
      yield put(validateCardsSuccess(data));
      history.push("/card-validation-preview");
    }
  } catch (err) {
    yield put(validateCardFailure(err));
  }
}

function* createCardsInBulkFunc(action) {
  const { history, successCard, bulkCardFormData, timezone } = action.payload;
  const data = yield call(createBulkCardAPI, { successCard, bulkCardFormData, timezone });
  yield put(addBulkCardResponse(data));

  if (data?.failedCard?.length === 0 && data?.successCard?.length > 0) {
    yield put(createCardsInBulkSuccess());
  } else {
    yield put(createCardsInBulkFailure());
    history.push('/card-order-finalize');
  }
}

export function* cardValidationSaga() {
  yield takeLatest(validateCards, validateCardsFunc);
  yield takeLatest(createCardsInBulk, createCardsInBulkFunc);
}